export default __webpack_public_path__ + "static/media/miwha.013e53ae.jpg";